
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

const FrozenGoldSection = () => {
  return (
    <section className="relative py-24 bg-black overflow-hidden">
      <div className="absolute inset-0 opacity-50">
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Frozen Gold
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            What started as a high school project evolved into a powerful catalyst for change in winter sports conservation.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative aspect-video rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm flex items-center justify-center"
          >
            <div className="text-2xl font-bold text-white">
              Coming Soon
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-white">A Student's Vision</h3>
              <p className="text-blue-200">
                What began as my high school film project at Mohawk Mountain transformed into something much bigger. Through the lens of my camera, I discovered not just a story about winter sports, but a calling to protect them.
              </p>
              <p className="text-blue-200">
                The project opened doors to conversations with industry leaders, renowned researchers, and passionate community members, each offering unique perspectives on the challenges facing our winter environments.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-white">Featured Perspectives</h3>
              <ul className="space-y-2">
                <li className="flex items-center text-blue-200">
                  <span className="text-green-400 mr-2">✓</span>
                  Industry Leaders & Athletes
                </li>
                <li className="flex items-center text-blue-200">
                  <span className="text-green-400 mr-2">✓</span>
                  Climate Research Scientists
                </li>
                <li className="flex items-center text-blue-200">
                  <span className="text-green-400 mr-2">✓</span>
                  Local Mountain Communities
                </li>
                <li className="flex items-center text-blue-200">
                  <span className="text-green-400 mr-2">✓</span>
                  Environmental Advocates
                </li>
              </ul>
            </div>

            <div className="pt-4">
              <Button
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                disabled
              >
                Coming Soon
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FrozenGoldSection;
